import { render, staticRenderFns } from "./ReviewOrderFiles.vue?vue&type=template&id=45c0a514"
import script from "./ReviewOrderFiles.vue?vue&type=script&lang=js"
export * from "./ReviewOrderFiles.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrderFiles.vue?vue&type=style&index=0&id=45c0a514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports